import { useSelector } from 'react-redux';
import { ADD_LAYER_TO_MAP, REMOVE_LAYER_FROM_MAP } from './actionTypes';
import { toast } from 'react-toastify';

const CheckLayer = (layer) => {
  const layers = useSelector((state) => state.layers);
  let isLayerAdded = layers.find((activeLayer) => activeLayer === layer);
  return isLayerAdded;
};

export const addLayerToMap = (map, layer) => {
  map.addLayer(layer);
  let layerName = layer.get('title');
  toast.success(`${layerName} katmanı haritaya eklendi.`);
  return {
    type: ADD_LAYER_TO_MAP,
    payload: layer,
  };
};

export const removeLayerFromMap = (map, layer) => {
  map.removeLayer(layer);
  let layerName = layer.get('title');
  toast.info(`${layerName} katmanı haritadan kaldırıldı.`);
  return {
    type: REMOVE_LAYER_FROM_MAP,
    payload: layer,
  };
};
